import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { StoreProvider } from "easy-peasy";
import store from "./store";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
